(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["color-swatches"] && !Shopify.designMode) return;
  try {
    // Each colour is its own product. Instead of loading a whole new page, a swatch click swaps in
  // the other product's section (fetched with the Section Rendering API) and updates the URL.
  // Hovering or touching a swatch starts fetching that section and its main image in advance.
  (() => {
    const sections = new Map();
    let currentPath = location.pathname;

    const fetchSection = (url, sectionId) => {
      const key = `${url}|${sectionId}`;
      if (!sections.has(key)) {
        const sectionUrl = new URL(url, location.origin);
        sectionUrl.searchParams.set('section_id', sectionId);
        const request = fetch(sectionUrl)
          .then((response) => {
            if (!response.ok) throw new Error(`Section request failed: ${response.status}`);
            return response.text();
          })
          .catch((error) => {
            sections.delete(key);
            throw error;
          });
        sections.set(key, request);
      }
      return sections.get(key);
    };

    const sectionIdFor = (element) => element.closest('.shopify-section')?.id.replace('shopify-section-', '');

    const warm = (event) => {
      const link = event.target.closest?.('.color-swatch-link');
      if (!link) return;
      fetchSection(link.href, sectionIdFor(link)).catch(() => {});

      const template = link.querySelector('[data-swatch-preload]');
      if (template) {
        // Importing the <img> into this document makes the browser fetch it without displaying it
        document.importNode(template.content, true);
        template.remove();
      }
    };

    // Each product lists its own colour first. On a swap, keep the order the visitor already sees
    // (the colour of the page they landed on stays first) instead of letting the swatches jump around
    const keepSwatchOrder = (oldSection, newSection) => {
      const swatches = newSection.querySelector('.color-swatches');
      if (!swatches) return;
      const pathOf = (link) => new URL(link.href, location.origin).pathname;
      const oldPaths = [...oldSection.querySelectorAll('.color-swatches > a')].map(pathOf);
      const rank = (link) => {
        const index = oldPaths.indexOf(pathOf(link));
        // Any colour the old page didn't list goes after the known ones
        return index === -1 ? oldPaths.length : index;
      };
      [...swatches.querySelectorAll(':scope > a')]
        .sort((a, b) => rank(a) - rank(b))
        .forEach((link) => swatches.append(link));
    };

    const swap = async (url, { push }) => {
      const section = document.querySelector('.shopify-section:has(.color-swatches)');
      if (!section) return location.assign(url);

      section.setAttribute('aria-busy', 'true');
      try {
        const html = await fetchSection(url, sectionIdFor(section));
        const newSection = document.adoptNode(
          new DOMParser().parseFromString(html, 'text/html').getElementById(section.id)
        );
        // Wait (briefly) for the main image so the swap doesn't flash an empty frame
        const mainImage = newSection.querySelector('.product-images img');
        await Promise.race([mainImage?.decode().catch(() => {}), new Promise((resolve) => setTimeout(resolve, 1000))]);

        keepSwatchOrder(section, newSection);

        const oldTitle = section.querySelector('[data-product-title]')?.dataset.productTitle;
        const newTitle = newSection.querySelector('[data-product-title]')?.dataset.productTitle;
        section.replaceWith(newSection);
        if (oldTitle && newTitle) document.title = document.title.replace(oldTitle, newTitle);

        if (push) history.pushState({}, '', url);
        currentPath = new URL(url, location.origin).pathname;
        document.dispatchEvent(new CustomEvent('product:replaced'));
      } catch (error) {
        location.assign(url);
      } finally {
        section.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('pointerover', warm);
    document.addEventListener('touchstart', warm, { passive: true });
    document.addEventListener('focusin', warm);

    document.addEventListener('click', (event) => {
      const link = event.target.closest('.color-swatch-link');
      if (!link || event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      swap(link.href, { push: true });
    });

    // Back/forward between colours; ignore hash-only changes (e.g. the header's href="#" toggles)
    window.addEventListener('popstate', () => {
      if (location.pathname !== currentPath) swap(location.href, { push: false });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-switcher"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#CountrySwitcher');
    const selector = document.querySelector('#CountrySelector');
    if (!form || !selector) return;
    selector.addEventListener('change', () => {
      form.submit();
    });
  });
  document.addEventListener('DOMContentLoaded', () => {
    const launchers = document.querySelectorAll('.country-switcher__launcher-button');
    if (!launchers.length) return;
    launchers.forEach((launcher) => {
      launcher.addEventListener('click', () => {
        const container = document.querySelector('.country-switcher__container');
        if (!container) return;
        const isOpen = container.classList.toggle('country-switcher__container--open');
        if (isOpen) document.querySelector('#CountrySelector')?.focus();
      });
    });
  });
  document.addEventListener('DOMContentLoaded', () => {
    const closeButton = document.querySelector('.country-switcher__close-button');
    if (!closeButton) return;
    closeButton.addEventListener('click', () => {
      const container = document.querySelector('.country-switcher__container');
      container.classList.toggle('country-switcher__container--open');
    });
  });
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.country-switcher__container');
    if (!container) return;
    container.addEventListener('click', (event) => {
      if (!event.target.closest('.country-switcher')) {
        container.classList.remove('country-switcher__container--open');
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') container.classList.remove('country-switcher__container--open');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('newsletter-popup');
    if (!popup) return;

    const STORAGE_KEY = 'newsletter-popup';
    const SHOW_AFTER_MS = 4000;
    const SNOOZE_MS = 30 * 24 * 60 * 60 * 1000;

    const read = () => {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
      } catch (error) {
        return {};
      }
    };
    const write = (value) => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      } catch (error) {}
    };

    // Sit just above Shopify's cookie banner while it's on screen, and drop down once it's gone
    const place = () => {
      const banner = document.getElementById('shopify-pc__banner');
      const rect = banner?.getBoundingClientRect();
      const offset = rect && rect.height > 0 ? Math.max(0, window.innerHeight - rect.top) : 0;
      popup.style.setProperty('--newsletter-banner-offset', `${offset}px`);
    };
    // Shopify adds/removes the banner as a direct child of <body>; hiding it shrinks it to 0×0
    const resizeObserver = new ResizeObserver(place);
    let observedBanner = null;
    const watchBanner = () => {
      const banner = document.getElementById('shopify-pc__banner');
      if (banner !== observedBanner) {
        if (observedBanner) resizeObserver.unobserve(observedBanner);
        if (banner) resizeObserver.observe(banner);
        observedBanner = banner;
      }
      place();
    };
    new MutationObserver(watchBanner).observe(document.body, { childList: true });
    watchBanner();
    window.addEventListener('resize', place);

    const show = () => {
      place();
      popup.hidden = false;
    };
    const close = () => {
      popup.hidden = true;
      if (read().status !== 'subscribed') write({ status: 'dismissed', at: Date.now() });
    };

    popup.addEventListener('click', (event) => {
      if (event.target.closest('[data-newsletter-close]')) close();
    });
    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });

    // The form posts normally (not via fetch): Shopify's hCaptcha spam protection adds its token
    // during a real submit. Shopify then redirects back to this page with the result rendered
    // into the form, so open the popup straight away to show it.
    popup.addEventListener('submit', (event) => {
      event.target.setAttribute('aria-busy', 'true');
    });

    const state = read();
    if (popup.querySelector('[data-newsletter-result="success"]')) {
      write({ status: 'subscribed' });
      show();
      setTimeout(() => (popup.hidden = true), 5000);
    } else if (popup.querySelector('[data-newsletter-result]')) {
      show();
      popup.querySelector('input[type="email"]')?.focus();
    } else if (state.status !== 'subscribed' && !(state.status === 'dismissed' && Date.now() - state.at < SNOOZE_MS)) {
      setTimeout(show, SHOW_AFTER_MS);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
